import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import classNames from 'classnames'

import { stripBaseUrl } from '../../utils/routing'
import { getCookie, setCookie, updateGtmConsent } from '../../utils/functions'

import ButtonBlueOutlineSmall from '../Buttons/ButtonBlueOutlineSmall/ButtonBlueOutlineSmall'

import styles from './CookieBanner.module.css'

export const CONSENT_TYPE = {
  NECESSARY: "necessary",
  FUNCTIONAL: "functional",
  ANALYTICS: "analytics",
  MARKETING: "marketing",
}

export const CONSENT_TO_USE_COOKIES = "consent-cookies"

export default class CookieBanner extends Component {
    static propTypes = {
        isOpenedSettings: PropTypes.bool.isRequired,

        onOpenSettings: PropTypes.func.isRequired,
    }
    
    constructor(props) {
        super(props)

        this.state = {
            showBanner: false,
            showSettings: false,

            consent: {
                necessary: true,
                functional: false,
                analytics: false,
                marketing: false,
            },
        }

        this.showBanner = this.showBanner.bind(this)
        this.setConsent = this.setConsent.bind(this)

        this.handleAcceptAll = this.handleAcceptAll.bind(this)
        this.handleRejectAll = this.handleRejectAll.bind(this)

        this.handleOpenSettings = this.handleOpenSettings.bind(this)
        //this.handleSettingsChange = this.handleSettingsChange.bind(this)
    }

    componentDidMount() {
        const cookieConsent = getCookie(CONSENT_TO_USE_COOKIES)
        if(!cookieConsent) {
            this.showBanner()
        } else {
            const parsed = JSON.parse(cookieConsent)
            this.setConsent(parsed)
            updateGtmConsent("update", parsed)
        }
    }

    showBanner = () => {
        this.setState({showBanner: true})
    }
    setConsent = (consent) => {
        this.setState({ consent: {
            necessary: consent.necessary, 
            functional: consent.functional,
            analytics: consent.analytics,
            marketing: consent.marketing,
        }})
    }

    handleOpenSettings = () => {
        this.setState({showBanner: false})
        this.props.onOpenSettings()
    }

    handleRejectAll = () => {
        const newConsent = { necessary: true, analytics: false, marketing: false, functional: false }

        this.setConsent(newConsent)
        setCookie(CONSENT_TO_USE_COOKIES, JSON.stringify(newConsent), { maxAge: 365 })
        updateGtmConsent("update", newConsent)

        this.setState({showBanner: false})
    }

    handleAcceptAll = () => {
        const newConsent = { necessary: true, analytics: true, marketing: false, functional: true }

        this.setConsent(newConsent)
        setCookie(CONSENT_TO_USE_COOKIES, JSON.stringify(newConsent), { maxAge: 365 })
        updateGtmConsent("update", newConsent)

        this.setState({showBanner: false})
    }

    /*handleSettingsChange = (newConsent) => {
        this.setConsent(newConsent)
        setCookie(CONSENT_TO_USE_COOKIES, JSON.stringify(newConsent), { maxAge: 365 })
        updateGtmConsent("update", newConsent)

        this.setState({showBanner: false})
    }*/

    /*handleSaveSettings = (newConsent) => {
        this.setConsent(newConsent)
        setCookie(CONSENT_TO_USE_COOKIES, JSON.stringify(newConsent), { maxAge: 365 })
        updateGtmConsent("update", newConsent)

        this.setState({showBanner: false, showSettings: false})
    }*/

    /*handleCloseSettings = () => {
        const cookieConsent = getCookie(CONSENT_TO_USE_COOKIES)
        if(!cookieConsent) {
            this.setState({showSettings: false})
            this.showBanner()
        } else {
            this.setState({showSettings: false})
        }
    }*/

    render() {
        const bannerStyle = classNames(styles.base, {
            [styles.isVisible]: this.state.showBanner,
            [styles[`hide-transition`]]: !this.state.showBanner,
        })

        return (
            <div className={bannerStyle}>
                <div className={styles.cookie_banner}>
                    <p className={styles.message}>
                    Мы используем cookie-файлы для улучшения работы сайта и предоставления вам более релевантной информации.
                    Вы можете настроить параметры cookie или отказаться от их использования. Если вы согласны с
                    «<Link 
                        key='cookie-policy'
                        to={ stripBaseUrl('https://tankimods.net/pages/cookie-policy/') }
                        state={{ slug: 'cookie-policy', lastUrl: document.location.href }}
                        className={ classNames(styles.link, styles.isExternal) }
                        //target={ target }
                        preventScrollReset={true}
                    >Политикой использования cookie-файлов</Link>», нажмите «Принять все cookie». Хотите изменить настройки cookie?&ensp;
                    <span onClick={() => this.handleOpenSettings()} className={styles.showSettings}>Настроить Cookie</span>
                    </p>
                    <div className={styles.actions}>
                        <ButtonBlueOutlineSmall onClick={() => this.handleRejectAll()}>Отклонить</ButtonBlueOutlineSmall>
                        <ButtonBlueOutlineSmall onClick={() => this.handleAcceptAll()}>Принять все cookie</ButtonBlueOutlineSmall>
                    </div>
                </div>
            </div>
        ) 
    } 
    /*<CookieSettings 
                isOpened={this.state.showSettings} 
                consent={this.state.consent} 
                onChange={(consentType) => this.handleSettingsChange(consentType)} 
                onSave={(consentType) => this.handleSaveSettings(consentType)} 
                onClose={(consentType) => this.handleCloseSettings(consentType)} 
        />*/
}
